/**
 * ConnectedLicenseBuilderComponent Container
 */

import * as actions from '../redux/actions/license';

import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from 'react-redux';

type ComponentStateProps = MapStateToProps<IOwnStateProps, ILicenseComponentProps, IStoreState>;
type ComponentDispatchProps = MapDispatchToProps<IOwnDispatchProps, ILicenseComponentProps>;
type ComponentMergeProps<E> =
  MergeProps<IOwnStateProps, IOwnDispatchProps, ILicenseComponentProps<E>, LicenseComponentProps<E>>;

interface IOwnStateProps {
  editingUsageIndex: number | null;
  medium: LicenseMediaTypeIdentifier | null;
  usages: ILicenseUsage[];
}

interface IOwnDispatchProps {
  setComponentForUsage(index: number, param: ILicenseComponent): void;
}

interface IOwnConnectedProps extends Pick<IOwnStateProps, 'editingUsageIndex' | 'medium'> {
  selectedParam: ILicenseComponent | ILicenseComponent[] | LicenseComponentType | null | undefined;
  setParam(param: ILicenseComponent | ILicenseComponent[] | null): void;
}

export type LicenseComponentProps<E> = IOwnConnectedProps & ILicenseComponentProps<E>;

function mapStateToProps(): ComponentStateProps {
  return ({ license: { editingUsageIndex, usages } }) => ({
    editingUsageIndex,
    medium: editingUsageIndex != null ? usages[editingUsageIndex].medium.id as LicenseMediaTypeIdentifier : null,
    usages,
  });
}

function mapDispatchToPropsFactory(
  componentId: LicenseComponentUsageParamName,
): ComponentDispatchProps {
  return (dispatch) => ({
      setComponentForUsage: (index, param) => {
        dispatch(actions.setComponentForUsage({
          component: componentId,
          index,
          value: param,
        }));
      },
    });
}

function mergePropsFactory<E>(
  componentId: LicenseComponentUsageParamName,
  nextStep?: number,
): ComponentMergeProps<E> {
  return ({ editingUsageIndex, medium, usages }, dispatchProps, ownProps) => {
      const selectedParam = editingUsageIndex !== null ?
        usages[editingUsageIndex!][componentId]
        : null;
      return {
        ...ownProps,
        editingUsageIndex,
        medium,
        selectedParam,
        setParam: (param: ILicenseComponent) => {
          dispatchProps.setComponentForUsage(editingUsageIndex!, param);
        },
      };
    };
}

function ConnectedLicenseBuilderComponent<E>(
  Component,
  componentId: LicenseComponentUsageParamName,
  nextStep?: LicenseBuildingStepNumber,
) {
  return connect(
    mapStateToProps,
    mapDispatchToPropsFactory(componentId),
    mergePropsFactory<E>(componentId, nextStep),
  )(Component);
}

export default ConnectedLicenseBuilderComponent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/containers/ConnectedLicenseBuilderComponent.tsx